import { useDynamicFeatureFlags } from "@/services/dynamic-feature-flags/components/DynamicFeatureFlagsProvider";

import { footerPreBuildData, footerRuBlockedPreBuildData } from "@/data";

type FooterJsonData =
  | typeof footerPreBuildData.forms
  | typeof footerRuBlockedPreBuildData.forms;

const craftFooterData = (footerJsonData: FooterJsonData) => {
  const responseArray: (typeof footerPreBuildData.forms)[] = [];

  const footerData = Array.from(footerJsonData);
  const allCount = footerData.length;
  const oneColCount = Math.floor(allCount / 4);

  for (let i = 0; i < 3; i++) {
    responseArray.push(
      footerData.splice(0, oneColCount).map((obj) => {
        return { ...obj };
      }),
    );
  }

  responseArray.push(
    [...footerData].map((obj) => {
      return { ...obj };
    }),
  );

  return responseArray;
};

export const useFooterData = () => {
  const { isBlockRUByCountry } = useDynamicFeatureFlags();

  return craftFooterData(
    isBlockRUByCountry
      ? footerRuBlockedPreBuildData.forms
      : footerPreBuildData.forms,
  );
};
